<template>
<div class="ion-padding">
    <div class="ion-padding-horizontal">
      <ion-label>ご入力いただいたメールアドレスに<br/>
        <span style="color: red">app@info.kutsu.com</span><br/>
        から認証コードをお送りします。<br/>
        <span style="color: red">「info.kutsu.com」と「chiyodagrp.co.jp」</span>からのメールを<br/>
        受信できるように設定をお願いいたします。<br/>
      </ion-label>

      <ion-item lines="none" id="domain-item" class="ion-margin-top">
        <ion-label id="domain-paragraph">{{ domain }}</ion-label>
        <ion-button id="domain-copy-button" @click="copyToClipboard" fill="clear">
          <ion-icon
              :icon="copyOutline"
              slot="start"
              style="font-size: 15px"
          ></ion-icon>
          ドメインをコピー
        </ion-button>
      </ion-item>

      <required-input label="メールアドレス" class="ion-margin-top"></required-input>
      <ion-input
          id="email"
          v-model="email"
          type="email"
          name="email"
          placeholder="メールアドレスを入力"
          label-placement="stacked"
          helper-text="例）yamada@example.co.jp ※半角英字で入力"
          fill="outline"
          mode="md"
          color="dark"
          :class="{ 'border-danger': (errors && errors.email)}"
      ></ion-input>
      <ion-text color="danger" v-if="errors && errors.email">{{ errors.email }}</ion-text>
      <ion-button class="ion-margin-vertical primary-button" expand="block" @click="registerSubmit">メールを送信する ></ion-button>

      <br/>
      <ion-label class="ion-margin-bottom" style="display: flex; align-items: center; font-size: 18px" color="danger">
        <ion-icon :icon="warning" style="font-size: 22px"></ion-icon>ご注意ください
      </ion-label>
      <ion-label>メールアドレスの入力間違いにより、<span style="color: red">認証コードメールが届かない</span>ケースが多発しております。<br/>
        今一度、入力間違いがないかご確認をお願いいたします。<br/>
        <br/>
        <span style="color: red">また、Googleのメール（～@gmail.com）、Yahoo!等、携帯変更に影響のないメールのご利用を推奨します。</span><br/>
        <br/>
        携帯会社のメール（@docomo.ne.jp、@ezweb.ne.jp、@softbank.ne.jp、等）をお使いの場合、迷惑メールフィルタ等の設定により、<span style="color: red">認証コードメールが届かない、または携帯会社変更に伴う機種変更</span>で以前のメールが受信できず<span style="color: red">データが引き継げない</span>というケースが発生しております。
      </ion-label>
    </div>
</div>
</template>

<script setup lang="ts">
import { useForm, useFormErrors, useField } from 'vee-validate';
import * as yup from 'yup';

import {
  IonLabel,
  IonText,
  IonInput,
  IonButton,
  IonIcon
} from "@ionic/vue";
import RequiredInput from "@/components/RequiredInput.vue";
import { copyOutline, warning } from "ionicons/icons";

const emits = defineEmits(['form-submit'])
const domain = "info.kutsu.com";

const schema = yup.object({
  email: yup.string()
    .required('メールアドレスをご入力ください')
    .email('メールアドレスが正しくありません').max(200, "メールアドレスは半角200文字以内でご入力ください")
})

const formRegisterMail = useForm({
  validationSchema: schema
})

const { value: email } = useField<string>("email")

const errors = useFormErrors() as any;
function copyToClipboard() {
  navigator.clipboard.writeText(domain);
}

async function registerSubmit() {
  const resp = await formRegisterMail.validate();

  if (resp.valid) {
    emits('form-submit', {email: formRegisterMail.values.email, formRegisterMail: formRegisterMail})
  }
}
</script>

<style scoped lang="scss">
#title {
  padding-left: 5px;
  border-left: solid 7px;
  border-color: gray;
  text-align: left;
}

.description {
  font-size: 0.75rem;
}

#domain-item {
  height: 32px;
  --min-height: 32px;
  --padding-start: 0;
  --inner-padding-end: 0;
}

#domain-paragraph {
  margin: 0 10px 0 1px;
  height: 30px;
  flex: 1;
  border: solid 1px;
  border-radius: 7px 0 0 7px;
  border-color: #808080;
  padding-left: 10px;
  font-size: 12px;
  line-height: 30px;
}

#domain-copy-button {
  height: 30px;
  margin: 0 0 0 0;
  --padding-start:2em;
  --padding-end:2em;

  color: black;
  font-size: 10px;
  --background: #e6e6e6;
}


#mail-address-containers {
  --inner-padding-top: 0px;
  --padding-start: 10px;
  --inner-padding-end: 0px;
  --min-height: 37px;
  margin-top:2rem;

  ion-input {
    padding:1.5rem;

  }
}

#send-mail-button {
  width: 100%;
  margin-top: 1rem;
  
}

.caution {
  margin: 10px auto;
  .caution-title {
    font-size: 1rem;
    font-weight: bold;
    margin: 0.25rem auto;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .caution-icon {
    color: #b7282d;
    margin: 0.25rem;
    font-size: 1.25rem;
  }
  .caution-label {
    color: #b7282d;
  }
}


#caution-description {
  margin: auto;
  padding: 15px;
  font-size: 0.75rem;
  border: solid 1px;
  border-radius: 10px;
  border-color: #e6e6e6;
}

.border-danger {
    --border-color: red;
    --border-width: 1px;
    border-radius: 5px;
}
</style>